import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';
import { getTestSeriesDetailsAPIKey } from '@cont/SeeAll/utils';
import { useRouter } from 'next/router';
import { HOST_TYPE } from '@utils/api-helper/host';

const useTestSeriesInfo = (
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { query } = useRouter();

  const key = getTestSeriesDetailsAPIKey(query.courseUID);

  const { data, isValidating, mutate, ...rest } = useFetch(
    key,
    { hostType: HOST_TYPE.TEST_SERIES },
    {
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  return {
    key,
    data: data || emptyObject,
    isValidating,
    mutate,
    ...rest
  };
};

export default useTestSeriesInfo;
